import { ReactNode } from 'react';
import { Text } from '@belong/ui';
import { Footer } from 'src/components/footer/footer';
import { Header } from 'src/components/header/header';
import { ReferralBanner } from '../../../homeowners/components/referral-banner/referral-banner';
import type { CitiesLandingPageProps } from './cities-landing-page';

export const getCitiesLandingPageLayout = (
  page: ReactNode,
  cityData: CitiesLandingPageProps['cityData'],
): ReactNode => {
  return (
    <div className="relative flex min-h-full flex-col">
      <ReferralBanner />
      <Header variant="secondary" theme="dark" />
      <div className="container relative flex justify-end">
        <Text as="h1" variant="p2" className="text-white">
          {!cityData.region?.name || cityData.region?.name === 'Nationally'
            ? ''
            : `${cityData.region?.region} `}
          Property Management
        </Text>
      </div>
      <main className="flex-1">{page}</main>
      <Footer />
    </div>
  );
};
